import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=bdd3bfc6&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=bdd3bfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd3bfc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd3bfc6')) {
      api.createRecord('bdd3bfc6', component.options)
    } else {
      api.reload('bdd3bfc6', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=bdd3bfc6&scoped=true&", function () {
      api.rerender('bdd3bfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ia2tRK0xG0TY/JS/teamMember.vue"
export default component.exports